import { authAxios } from "../axios";
import { AdTimeCode, AdvDetail } from "./advertisement.types";

class AdvertisementRequest {
  static async getTimeCodes(id: number) {
    return authAxios.get<AdTimeCode[]>(`/advertisement/time-codes?content_id=${id}`).then((res) => res.data);
  }
  static async getAdvDetail(id: number) {
    return authAxios.get<AdvDetail>(`/advertisement/${id}`).then((res) => res.data);
  }
}

export default AdvertisementRequest;
